// Import JS Modules
import UrlBuilder from '../../_utils/url-building';
import { usePrismItemStore } from './usePrismItemStore';


// --------------------------------------------------------------------

class EmbellishmentStoreBase {
  constructor() {
    this.categoriesList = null;
  }

  async some() {
    const categories = this.categoriesList || await this.fetchCategories();

    return categories.length > 0;
  }

  async getEmbellishments(query) {
    // is the query a category id?
    const category = this.categoriesList.find((c) => c.id === query);

    const [title, url] = category
      ? [category.title, category.feed, category.title] // the query is a category id
      : [query, this.tagsUrl(query)]; // otherwise perform a tags search

    return {
      title,
      items: await this.fetchEmbellishments(url),
    };
  }

  async fetchCategories() {
    this.categoriesList = await this._fetch(this.categoriesUrl) || [];

    return this.categoriesList;
  }

  async fetchEmbellishments(url) {
    const data = await this._fetch(url);

    let embellishments = [].concat(
      data.embellishments.map((embellishment) => ({
        ...embellishment,
        type: data.types[embellishment.type],
      }))
    );

    if (data.pages.next) {
      embellishments = embellishments.concat(await this.fetchEmbellishments(data.pages.next));
    }

    return embellishments;
  }

  async _fetch(url) {
    if (!url) {
      return;
    }

    const response = await fetch(url, {
      mode: 'cors',
      credentials: 'omit',
    });

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    return await response.json();
  }

  get categoriesUrl() {
    if (this.baseUrl) {
      return `${this.baseUrl}/api/categories?${this.buildURLQuery()}`;
    }
  }

  tagsUrl(query) {
    const queryString = this.buildURLQuery({
      tag: query,
    });

    return `${this.baseUrl}/api/feed?${queryString}`;
  }

  buildURLQuery(params = {}) {
    return UrlBuilder.buildURLQuery({
      type: this.type,
      design_code: this.designCode,
      rights_holder: this.rightsHolder,
      ...params,
    });
  }

  get baseUrl() {
    return (wkData.embellishments_service || {}).url;
  }

  get designCode() {
    return usePrismItemStore.getState().prismItem.design_code;
  }

  get rightsHolder() {
    return wkData.embellishments_service.rights_holder;
  }
}

class StickerStore extends EmbellishmentStoreBase {
  get type() {
    return 'sticker';
  }
}

class PatternStore extends EmbellishmentStoreBase {
  get type() {
    return 'pattern';
  }
}

// --------------------------------------------------------------------

export {
  StickerStore,
  PatternStore,
};
